<div class="users-component" [ngClass]="{ 'dx-rtl': rtlEnabled }" dir="{{rtlEnabled ? 'rtl' : 'ltr'}}">
  <div class="item-list-component">
    <div class="grid-buttons">
      <!--<dx-button
        hint="{{ 'SHARED.ADD' | translate }}"
        icon="add"
        (onClick)="add()"
      ></dx-button>-->
      <dx-button hint="{{ 'SHARED.PRINT' | translate }}"
                 icon="print"
                 (onClick)="print()"></dx-button>
    </div>
    <br />
    <dx-data-grid #supplierUsersGrid
                  id="printSection"
                  [rtlEnabled]="rtlEnabled"
                  [dataSource]="items"
                  [showBorders]="true"
                  (onRowClick)="edit($event)"
                  [allowColumnReordering]="true"
                  [hoverStateEnabled]="true"
                  [columnAutoWidth]="true"
                  [rowAlternationEnabled]="true"
                  (onExporting)="onExporting($event)">
      <dxo-export [enabled]="true"></dxo-export>
      <dxo-selection mode="single"></dxo-selection>
      <dxo-filter-row [visible]="true"></dxo-filter-row>
      <dxo-filter-panel [visible]="true"></dxo-filter-panel>
      <dxo-header-filter [visible]="true"></dxo-header-filter>
      <dxo-search-panel [visible]="true"></dxo-search-panel>
      <dxo-pager [visible]="true"
                 [showPageSizeSelector]="true"
                 [allowedPageSizes]="[5, 10, 20, 30, 40, 50, 100, 200]"
                 [showNavigationButtons]="true"
                 [showInfo]="true"
                 infoText="{2} {{ 'SHARED.PAGINATION_TEXT_PLACEHOLDER' | translate | slice:2 }}"></dxo-pager>
      <dxi-column [editorOptions]="{ showClearButton: true }" dataType="boolean" dataField="isActive" caption="{{ 'SHARED.IS_ACTIVE' | translate }}">
      </dxi-column>
      <dxi-column [editorOptions]="{ showClearButton: true }" dataType="string" dataField="email" caption="{{ 'SHARED.EMAIL' | translate }}">
      </dxi-column>
      <dxi-column [editorOptions]="{ showClearButton: true }" dataType="string" dataField="firstname" caption="{{ 'SHARED.FIRST_NAME' | translate }}">
      </dxi-column>
      <dxi-column [editorOptions]="{ showClearButton: true }" dataType="string" dataField="lastname" caption="{{ 'SHARED.LAST_NAME' | translate }}">
      </dxi-column>
      <dxi-column type="buttons">
        <dxi-button hint="{{ 'SHARED.EDIT' | translate }}" icon="edit" [onClick]="edit"></dxi-button>
        <dxi-button hint="{{ 'SHARED.DELETE' | translate }}" icon="trash" [onClick]="deleteItem"></dxi-button>
      </dxi-column>
    </dx-data-grid>
  </div>

  <!--<authentication-component></authentication-component>-->
  <supplier-user-component #details
                           (onClosed)="onDetailsComponentClosed($event)"></supplier-user-component>
  <confirmation-component #confirmation title="{{ 'USERS.DELETE' | translate }}"
                          message="{{ 'USERS.DELETE_MESSAGE' | translate }}"
                          buttonCloseText="{{ 'SHARED.DELETE' | translate }}" cancellable="true" (close)="deleteSelected();"></confirmation-component>
</div>
